export const chunk = (arr, count) => {
  const cloneArr = [...arr];
  const result = [];
  while (cloneArr.length) {
    result.push(cloneArr.splice(0, count));
  }
  return result;
};
